import { Routes, Route } from 'react-router-dom';

import Home from './components/home/home.jsx';
import './App.scss';
import NoMatch from './routes/no-match.jsx';

const App = function () {
	return (
		<div className="App">
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="*" element={<NoMatch />} />
			</Routes>
		</div>
	);
};

export default App;
